// extracted by mini-css-extract-plugin
module.exports = {"menuBlock":"md","title":"nd","nav":"od","flexCell":"pd","facetLink":"qd"};